import { Button } from '@components/v2/button'
import HandIcon from 'images/hand-icon.svg'

export const FeedbackButton = ({ onClick }: { onClick: () => void }) => (
  <Button
    onClick={onClick}
    variant="outline"
    className="h-[36px] bg-white border-[#0092F3] text-[#0092F3] hover:bg-[#0092F3] hover:text-white"
  >
    <HandIcon className="fill-current hover:fill-white" />
  </Button>
)
